import Vue from 'vue'
import moment from 'moment'
import {
  formatImage,
  formatMoney,
  timeDiff,
  miniPrice,
  fixDate,
  formatNumber,
  indexToString,
  formatScore,
  filterTimeFormat,
  numberConvert,
  fixFloatMoney,
  addZero
} from '@/utils/utils'

Vue.filter('formatMoney', formatMoney)
Vue.filter('formatImage', formatImage)
Vue.filter('timeDiff', timeDiff)
Vue.filter('miniPrice', miniPrice)
Vue.filter('fixDate', fixDate)
Vue.filter('formatNumber', formatNumber)
Vue.filter('indexToString', indexToString)
Vue.filter('formatScore', formatScore)
Vue.filter('filterTimeFormat', filterTimeFormat)
Vue.filter('to_cn_unit', numberConvert)
Vue.filter('fixFloatMoney', fixFloatMoney)
Vue.filter('addZero', addZero)
Vue.filter('to_cn_time', function (milliseconds) {
  if (milliseconds) {
    const duration = moment.duration(milliseconds, 'milliseconds')
    const hours = Math.floor(duration.asHours())
    const minutes = Math.floor(duration.asMinutes()) - hours * 60
    const second = Math.floor(duration.asSeconds()) - hours * 60 - minutes * 60
    return `${hours ? hours + '小时' : ''}${
      minutes ? minutes + '分' : ''
    }${second}秒`
  } else {
    return '0秒'
  }
})
